<button
  class="ui-mascot"
  type="button"
  [attr.data-size]="size()"
  [attr.data-eyes]="resolvedEyes()"
  [attr.data-animation]="animation()"
  [attr.aria-label]="resolvedImage().alt"
  (click)="onMascotClick()"
>
  <span class="ui-mascot__image-shell">
    <img
      class="ui-mascot__image"
      [src]="resolvedImage().src"
      [alt]="resolvedImage().alt"
      width="168"
      height="168"
      loading="lazy"
      decoding="async"
    />
  </span>

  @if (shouldShowThought()) {
    <span class="ui-mascot__thought" aria-live="polite">
      @if (thoughtEmoji()) {
        <span class="ui-mascot__thought-emoji">{{ thoughtEmoji() }}</span>
      }

      @if (thoughtText()) {
        <span class="ui-mascot__thought-text">{{ thoughtText() }}</span>
      }
    </span>
  }
</button>